// Dealer IDs whose email and phone contact details should not be displayed to sellers.
// A more dynamic solution will replace this once the data is accessible through existing API calls.
export const RESTRICTED_DEALER_IDS: ReadonlySet<number> = new Set([
  343, 1011, 1043, 1044, 1125, 1298, 1300, 1431, 1453, 1480,
  1523, 1633, 1659, 1814, 1909, 1943, 2477, 3781, 4151, 4314,
  4477, 4824, 5596, 6452, 6727, 7043, 7843, 8531, 8621, 8874,
  9106, 9169, 9604, 10346, 11328, 12067, 12164, 12346, 12820,
  17771, 18380, 18775, 20405, 37672, 43313, 44158, 45712, 60078,
  60079, 60080, 60081, 60082,
]);

export const isDealerIdRestricted = (dealerId: number | undefined | null): boolean =>
  typeof dealerId === 'number' && RESTRICTED_DEALER_IDS.has(dealerId);
